// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3F_96","notes":"Notes_notes__pb6kk","note":"Notes_note__2couJ","markdown":"Notes_markdown__2xVpV"};